import {
  DECORATION_BACKGROUND,
  M_STATUS_REJECTED,
  M_STATUS_VERIFYING,
  THEME_WHITE_BLUE,
  THEME_WHITE_GREEN,
  THEME_WHITE_PINK
} from '@constant'
import { dGet } from '@core/utils'
import Img from '@UI/Img'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import Rowbox from '../Common/Rowbox'
import style from './style.module.less'

/**
 * 商家故事
 */
@observer
export default class extends Component {
  getStatus = allStatus => {
    let status = ''
    const textStatus = dGet(allStatus, 'pending_data.des.status')
    const photoStatus = dGet(allStatus, 'pending_data.real_photos.status')
    if (textStatus == M_STATUS_REJECTED || photoStatus == M_STATUS_REJECTED) {
      status = 'rejected'
    } else if (
      textStatus == M_STATUS_VERIFYING ||
      photoStatus == M_STATUS_VERIFYING
    ) {
      status = 'verifying'
    }

    return status
  }

  /**
   * 铜牌、普通不显示
   */
  getMerchantGrade = type => {
    switch (+type) {
      case 2:
        return (
          <img
            className={style.starIcon}
            src="//qnm.hunliji.com/o_1cmpanpjbkbu1mi19fq1mcejova.png"
          />
        )
      case 3:
        return (
          <img
            className={style.starIcon}
            src="//qnm.hunliji.com/o_1cmpanpjbnbs7cq1qpo11fo1qo39.png"
          />
        )
      case 4:
        return (
          <img
            className={style.starIcon}
            src="//qnm.hunliji.com/o_1cmpanpjblk0d7e1t0g7q51ihlb.png"
          />
        )
      default:
        return null
    }
  }

  render() {
    const {
      store: { homeData, allStatus, themeConfig, theme, newThemeConfig }
    } = this.props

    const {
      name,
      logo_path_square,
      logo_path,
      comments_count,
      fans_count,
      address,
      grade,
      merchant_comment
    } = homeData

    const status = this.getStatus(allStatus)

    return (
      <>
        <Rowbox
          type={DECORATION_BACKGROUND}
          store={this.props.store}
          style={Object.assign(
            {},
            {
              height: 168,
              padding: 0,
              background: 'transparent'
            },
            +theme === THEME_WHITE_BLUE ||
            +theme === THEME_WHITE_PINK ||
            +theme === THEME_WHITE_GREEN
              ? { color: '#fff' }
              : {}
          )}
          status={status}
        >
          <Img
            src="//qnm.hunliji.com/o_1cfmrom721ou211hlqva18i1ksc7.png"
            style={{
              width: 373,
              height: 100,
              position: 'absolute',
              top: '0',
              left: '0'
            }}
          />
          <Img
            src="//qnm.hunliji.com/o_1cn6b1p4m132v1t015tp1phd1mhc9.png"
            style={{
              width: 20,
              height: 20,
              position: 'absolute',
              top: '39px',
              left: '246px'
            }}
          />
          <div className={style.background}>
            <div className={style.merchant}>
              <div className={style.logo}>
                <Img
                  src={logo_path_square || logo_path}
                  width={64}
                  height={64}
                />
              </div>
              <div className={style.description}>
                <div className={style.merchantName}>
                  <span className={style.name}>{name}</span>
                  <img className={style.icon} src={themeConfig['nameIcon']} />
                </div>
                <div className={style.info}>
                  {this.getMerchantGrade(grade)}
                  <span className={style.gradeStar}>
                    <img
                      className={style.star}
                      src={newThemeConfig['coverStar']}
                    />
                    {dGet(merchant_comment, 'score', '')}
                  </span>
                  <span className={style.grade}>
                    {comments_count !== undefined ? `${comments_count}条` : ''}
                  </span>
                  <span className={style.grade}>
                    {fans_count !== undefined ? `${fans_count}关注` : ''}
                  </span>
                </div>
              </div>
            </div>
            <div className={style.address}>
              <span className={style.addressText}>{address}</span>
              <span className={style.addressLogo}>
                {address !== undefined ? (
                  <Fragment>
                    <span>
                      <img
                        style={{
                          width: 13,
                          height: 13,
                          margin: '-4px 5px 0 0'
                        }}
                        src={themeConfig['positionIcon']}
                      />
                    </span>
                    <span>导航</span>
                  </Fragment>
                ) : null}
              </span>
            </div>
          </div>
        </Rowbox>
      </>
    )
  }
}
